import React, { useEffect } from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { BlockchainMonitorProvider, BlockchainStatusDock } from '@kxdex/shared';
import LandingPage from '@/pages/LandingPage';
import TestEntry from '@/pages/TestEntry';

/** 路由切换时自动滚动到顶部 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <BlockchainMonitorProvider>
      <ScrollToTop />
      <Box sx={{ pb: '58px' }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/entry" element={<TestEntry />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>
      <BlockchainStatusDock accentColor="#1976d2" />
    </BlockchainMonitorProvider>
  );
};

export default App;
